@if (isLoading) {
	<div class="overlay-new"></div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'mes.administration.team-profiles.team-profiles' | translate }}</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field>
				<input matInput (keyup)="applyFilter($event)" [placeholder]="'insights.administration.users.search' | translate" #input [cdkTrapFocusAutoCapture]="showSearch" [cdkTrapFocus]="showSearch" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
		<header-sub-menu [favoriteItems]="favoriteItems" [menuItems]="menuItems"></header-sub-menu>
	</div>
</div>

<table class="table-responsive" mat-table recycleRows [dataSource]="dataSource" matSort (matSortChange)="onSort($event)">
	<ng-container matColumnDef="description">
		<th mat-header-cell *matHeaderCellDef mat-sort-header>
			{{ 'mes.administration.team-profiles.alias' | translate }}
		</th>
		<td mat-cell *matCellDef="let element">({{ element.alias }}) {{ element.description }}</td>
	</ng-container>

	<ng-container matColumnDef="menu">
		<th mat-header-cell *matHeaderCellDef style="text-align: end"></th>
		<td mat-cell *matCellDef="let row" style="text-align: end">
			<button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Edit team profile settings">
				<mat-icon mat-list-icon svgIcon="acies_overflow_menu" style="padding-top: 5px"></mat-icon>
			</button>
			<mat-menu #menu="matMenu">
				<button mat-menu-item (click)="openTeamProfile(row.profile)">
					<span>{{ 'mes.administration.team-profiles.editbtn' | translate }}</span>
				</button>
			</mat-menu>
		</td>
	</ng-container>

	<ng-container>
		<td mat-cell *matCellDef="let element">
			<table class="table-responsive" mat-table recycleRows [dataSource]="element.configurations" matSort></table>
		</td>
	</ng-container>

	<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
	<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>

<mat-paginator [pageSizeOptions]="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000]" [pageSize]="1000" showFirstLastButtons></mat-paginator>
